import {Component, Input, input, InputSignal, signal, ViewEncapsulation} from '@angular/core';
import {SvgIconComponent} from "../svg-icon/svg-icon.component";
import {NgClass, NgIf} from "@angular/common";
import {CardType} from "../../enums/cardType";

@Component({
  selector: 'app-card-with-image',
  standalone: true,
  imports: [
    SvgIconComponent,
    NgIf,
    NgClass
  ],
  templateUrl: './card-with-image.component.html',
  styleUrl: './card-with-image.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CardWithImageComponent {
  indicator = input(0);
  desc = input<string>();
  icon = input.required<string>();
  cardTitle= input('');
  type=input.required<string>();
  withIndicator = input.required();
  protected readonly CardType = CardType;
}
